module.exports = __webpack_public_path__ + "img/jm.fcb8c1e5.svg";